import type { ScheduleViewAction } from "@/pages/human-resources/time-management/model/schedule-view/ScheduleViewAction.ts";
import type { Dispatch } from "react";
import { createContext } from "react";

export const ScheduleViewStateDispatchContext = createContext<
  Dispatch<ScheduleViewAction> | undefined
>(undefined);
